import { ACTIONS } from "../../../Models/ENUM";
import DATE from "../../../UTIL/DATE";
import TimerInstance from "../../../UTIL/Instances/TimerInstance";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";
import GameCurrency from "../WALLET/GameCurrency";
import InventoryItem from "../INVENTORY/InventoryItem";
import LOG, { log } from "../../../UTIL/LOG";
import ARRAY from "../../../UTIL/ARRAY";
import Messages from "./Messages";


class MessageItem
{
    public fromAvatarID : string;
    public toAvatarID   : string;
    public Messages     : Messages;
    public fullName     : any;
    public userPhoto    : any;
    public avatarID     : any;
    public type         : string;
    public data         : any;
    public timestamp    : any;
    public messageID    : any;
    public isRead       : boolean;
    public isConsumed   : boolean;
    public isReplied    : boolean;

    private conquer     : CONQUER;

    constructor( Messages:Messages, vars:any )
    {
        this.Messages       = Messages;
        this.conquer        = Messages.conquer;
        this.messageID      = vars._id;
        this.fromAvatarID   = vars.fromAvatarID;
        this.toAvatarID     = vars.toAvatarID;
        this.avatarID       = vars.fromAvatarID;

        this.data           = vars.data || {};
        this.type           = this.data.type || "Message";
        this.timestamp      = vars.timestamp;
        this.isRead         = vars.isRead || false;
        this.isConsumed     = vars.isConsumed || false;
        this.isReplied      = vars.isReplied || false;

        let self            = this;

        this.Messages.conquer.Avatars.get( this.fromAvatarID ).then( function( Avatar )
        {
            self.fullName   = Avatar.fullName;
            self.userPhoto  = Avatar.userPhoto;
        });
    }

    public async remove() : Promise<any>
    {
        await this.conquer.do( ACTIONS.GAME_MESSAGES_REMOVE, { _id:this.messageID } );
        return Promise.resolve();
    }

    public async setRead() : Promise<any>
    {
        this.isRead = true;
        await this.conquer.do( ACTIONS.GAME_MESSAGES_CHANGE, { where:{ _id:this.messageID }, values:{ isRead:true } } );
        return Promise.resolve();
    }

    public async setConsumed() : Promise<any>
    {
        this.isConsumed = true;
        await this.conquer.do( ACTIONS.GAME_MESSAGES_CHANGE, { where:{ _id:this.messageID }, values:{ isConsumed:true } } );
        return Promise.resolve();
    }

    public async setReplied() : Promise<any>
    {
        this.isReplied = true;
        await this.conquer.do( ACTIONS.GAME_MESSAGES_CHANGE, { where:{ _id:this.messageID }, values:{ isReplied:true } } );
        return Promise.resolve();
    }

 
}

export default MessageItem;